export default __webpack_public_path__ + "static/media/ic_common_clear.c956883f.svg";